import {Component, OnInit, signal} from '@angular/core';
import {CodaltComponent} from '../codalt.component';
import {PpeEquipment} from '../ppe-equipment';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {Router, RouterLink} from '@angular/router';
import {Routenames} from '../route-names.enum';
import {SmallMaterial} from '../smallmaterial';
import {SmallMaterialService} from '../services/small-material.service';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIconButton} from "@angular/material/button";

@Component({
    selector: 'app-small-material-management',
    templateUrl: './small-material-management.component.html',
    styleUrls: ['./small-material-management.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip,
        MatIconButton
    ]
})
export class SmallMaterialManagementComponent extends CodaltComponent implements OnInit {

    smallMaterials = signal<SmallMaterial[]>([]);
    currentSort = signal<string>(null);
    desc = signal<boolean>(false);

    constructor(
        private smallMaterialService: SmallMaterialService,
        private confirmDialog: ConfirmDialogService,
        private router: Router
    ) {
        super();
    }

    ngOnInit(): void {
        this.smallMaterialService.listMaterials().subscribe(equipment => {
            this.smallMaterials.set(equipment.data);
        });
    }

    edit(equipment: PpeEquipment) {
        this.router.navigate([Routenames.smallMaterial, equipment.id]);
    }

    sortList(sortingOn) {
        let materials = this.smallMaterials();
        this.smallMaterials.set([]);

        if (sortingOn === this.currentSort()) {
            materials = materials.reverse();
            this.desc.set(!this.desc());
        } else {
            this.desc.set(false);
            materials = materials.sort((a, b) => {
                if (a[sortingOn].toUpperCase() < b[sortingOn].toUpperCase()) {
                    return -1;
                }
                if (a[sortingOn].toUpperCase() > b[sortingOn].toUpperCase()) {
                    return 1;
                }
                return 0;
            });
        }

        this.smallMaterials.set(materials);

        this.currentSort.set(sortingOn);
    }

    delete(event, equipment: PpeEquipment) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Materiaal verwijderen',
            `Weet u zeker dat u materiaal ${equipment.name} wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        ).then(() => {
            this.smallMaterialService.deleteMaterial(equipment.id).subscribe(() => {
                const index = this.smallMaterials().indexOf(equipment);
                this.smallMaterials().splice(index, 1);
            });
        }, () => {

        });
    }

}
